import { useMemo } from 'react';
import { useNavigate } from 'react-router';
import {
  FileBrowser,
  JARVIS_ADD_TO_ANALYTICS,
  isAnalyticsSourceFileName
} from '@jarvis/platform-ui';
import { useHasRole } from '../../auth/useHasRole';
import { useSiteCapabilitiesStore } from '../../site/useSiteCapabilitiesStore';

export function FilesPage() {
  const navigate = useNavigate();
  const { canAccessElevatedApps } = useHasRole();
  const analyticsEnabled = useSiteCapabilitiesStore((s) => s.analyticsEnabled);
  const extraFileActions = useMemo(
    () =>
      analyticsEnabled && canAccessElevatedApps()
        ? [
            {
              name: JARVIS_ADD_TO_ANALYTICS,
              text: 'Add to Analytics',
              icon: 'chart',
              accept: isAnalyticsSourceFileName,
              onSelect: (files: Array<{ mountId: string; path: string }>) => {
                const file = files[0];
                if (!file) return;
                const params = new URLSearchParams({
                  mountId: file.mountId,
                  path: file.path
                });
                navigate(`/apps/analytics/data-sources?${params.toString()}`);
              }
            }
          ]
        : [],
    [analyticsEnabled, canAccessElevatedApps, navigate]
  );

  return (
    <div className="ops-fill-page ops-fill-page--bare">
      <FileBrowser extraFileActions={extraFileActions} />
    </div>
  );
}
